import {ProcessHook, ProcessHookProps, ProcessHookRunProps} from "./process-hooks";
import {JsonObject} from "typescript-json-serializer";

/**
 * Hook to check project validity
 */
@JsonObject()
export class ValidateProjectHook extends ProcessHook {

    class = "ValidateProjectHook";
    constructor(props?: ProcessHookProps) { super(props); }

    run(runProps: ProcessHookRunProps): Promise<any> {
        return new Promise((resolve, reject) => {
            const {project, auftragsverwaltung} = runProps;

            if (!project.id) {
                reject("Projekt oder Projekt-ID nicht definiert.");
                return;
            }

            const promises = [
                this.checkPerimeters(project, auftragsverwaltung),
                this.checkPartialOrders(project, auftragsverwaltung)
            ];

            Promise.all(promises).then((values) => {
                resolve(values);
            }).catch((error) => {
                // TODO: Mehr Kontext reinpacken
                reject(error);
            });
        });
    }

    private checkPerimeters(project, auftragsverwaltung): Promise<string> {
        return new Promise((resolve, reject) => {
            auftragsverwaltung.ProjectPerimeterStore.loadItems(project.id).then((perimeters) => {
                if (perimeters && perimeters.length > 0) {
                    resolve("Perimeter vorhanden.");
                    return;
                } else {
                    // get from db
                    reject("Bitte einen Projektperimeter festlegen.");
                }
            });
        });
    }

    private checkPartialOrders(project, auftragsverwaltung): Promise<string> {
        return new Promise((resolve, reject) => {
            if (project.typeId === 4) {
                // risikoübersicht. min 1 partial orders for risk
                auftragsverwaltung.PartialOrderRiskStore.loadItems(project.id).then((po) => {
                    if (po && po.length > 0) {
                        resolve("Teilaufträge ok.");
                    } else {
                        reject("Mindestens einen Teilauftrag erfassen.");
                    }
                });
            }
            else {
                const promises: any[] = [];
                if (project.typeId === 1 || project.typeId === 3) {
                    // min 1 partial order gk
                    promises.push(auftragsverwaltung.PartialOrderGkStore.loadItems(project.id));
                }
                if (project.typeId === 2 || project.typeId === 3) {
                    // min 1 partial order ghk
                    promises.push(auftragsverwaltung.PartialOrderGhkStore.loadItems(project.id));
                }
                Promise.all(promises).then((values) => {
                    const partailOrdersValid = values.map((po) => po.length > 0);
                    if (partailOrdersValid.every((po) => po)) {
                        resolve("Teilaufträge ok.");
                    } else {
                        reject("Mindestens einen Teilauftrag erfassen.");
                    }
                }).catch((error) => {
                    reject(error);
                });
            }
        });
    }
}
